import { ca } from '@cian/analytics';

import { TTrackingParamsType } from '../../types/page/trackingParamsType';

export const trackPageOpen = ({ dealType, cianSource, siteType }: TTrackingParamsType) => {
  ca('eventSite', {
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      pageType: 'OnlineRentContract',
      siteType,
      extra: {
        dealType,
        cian_source: cianSource,
      },
    },
  });
};
